  <!-- <mat-dialog-content class="customer-dialog">
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
        <div class="accounts">
          <ul>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="search-container">
           <mat-form-field>
      <mat-label>Doctor Code</mat-label>
      <input matInput [(ngModel)]="docCode" (keyup)="retriveDoctorsLookup()">
    </mat-form-field>

           <mat-form-field >
      <mat-label>Doctor Name</mat-label>
      <input matInput [(ngModel)]="docName" (keyup)="retriveDoctorsLookup()">
    </mat-form-field>


        </div>
      </div>
    </div>
  </section>
<div class="table-container">
  <table class="customer-table">
    <thead>
      <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">Doctor Code</th>
        <th style="width: 100%;">Doctor Name</th>
        <th style="width: 20%;">Choose</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of doctorsList; let i = index">
        <td data-column="Doctor ID">{{Do.docCode}}</td>
        <td data-column="Doctor Name">{{Do.docName}}</td>

        <td data-column="Choose"><button  mat-raised-button style="color: white;background-color: rgb(0, 0, 128);" id="select" name="select"
            (click)="SelectDoctors(Do)">Select</button>
        </td>
      </tr>

    </tbody>
  </table>
  </div>
</mat-dialog-content> -->



<mat-dialog-content class="customer-dialog">
  <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Doctor Code</mat-label>
      <input matInput [(ngModel)]="docCode" (keyup)="retriveDoctorsLookup()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Doctor Name</mat-label>
      <input matInput [(ngModel)]="docName" (keyup)="retriveDoctorsLookup()">
    </mat-form-field>

  </div>

  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">Doctor Code</th>
        <th style="width: 100%;">Doctor Name</th>
        <th style="width: 20%;">Choose</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let Do of doctorsList; let i = index">
        <td>{{Do.docCode}}</td>
        <td>{{Do.docName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectDoctors(Do)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>

